var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Arrow-Left_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Arrow-Left_svg__st1{fill:none;stroke:currentColor;stroke-linecap:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-Left_svg__Stroke",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow-Left_svg__Stroke-Copy",
    d: "M60 30c0 16.6-13.4 30-30 30S0 46.6 0 30 13.4 0 30 0s30 13.4 30 30z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-Left_svg__icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Arrow-Left_svg__st1",
    d: "M14.6 25.9l13.1-13L14.6 0M27.2 12.9H.3",
    transform: "rotate(180 23 22.5)"
  }))));
};
export default SvgArrowLeft;